var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Magnifying-glass-icon",
    transform: "translate(0.2001953 0.2000122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3991 11.9767C13.8107 4.6562 21.1623 -0.0173296 29.2387 9.68624e-05C38.3857 0.0259346 46.4353 6.0423 49.0503 14.8076C51.6654 23.5729 48.228 33.0162 40.5904 38.0496C32.9527 43.083 22.9192 42.5172 15.8958 36.6571L3.07576 49.4771C2.7377 49.8124 2.28073 50.0004 1.80458 50C1.07601 50.0006 0.418686 49.5626 0.138607 48.8901C-0.141472 48.2175 0.0107383 47.4424 0.52438 46.9257L13.3444 34.1057C8.13687 27.9324 6.98756 19.2971 10.3991 11.9767ZM29.2387 37.9192C19.7784 37.9192 12.1093 30.2501 12.1093 20.7898C12.1093 11.3295 19.7784 3.66039 29.2387 3.66039C38.699 3.66039 46.3681 11.3295 46.3681 20.7898C46.3384 30.2378 38.6867 37.8895 29.2387 37.9192ZM28.0206 8.47752C28.2844 8.07848 28.3788 7.59099 28.2831 7.12233C28.0758 6.14935 27.1197 5.52808 26.1464 5.73395C21.3123 6.74079 17.2531 10.0023 15.2286 14.506C14.9159 15.0994 14.9585 15.8173 15.339 16.3697C15.7196 16.922 16.3753 17.2174 17.0412 17.1366C17.707 17.0557 18.273 16.6119 18.5103 15.9846C20.0592 12.5291 23.1701 10.025 26.8767 9.24999C27.3453 9.15443 27.7569 8.87656 28.0206 8.47752Z",
    transform: "matrix(-1 0 0 1 49.91739 0)",
    id: "Shape",
    fill: "#1DA1F2",
    fillRule: "evenodd",
    stroke: "#1DA1F2",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassIcon);
export default __webpack_public_path__ + "static/media/magnifying-glass-icon.b33673ccef22e4b31a71811dab5d904e.svg";
export { ForwardRef as ReactComponent };